export const ControlSource = {
  SYSTEM: 'system',
  USER: 'user',
};